import DigitalMagazinePage, {
    loader,
} from '~/routes/_app.digital-magazines._index';

export { loader };
export default DigitalMagazinePage;
